import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getHomeDesktopConfig } from "@/utils/homeDesktop.functions";
import {
  HOME_DESKTOP_DEFAULTS,
  type HomeDesktopConfig,
} from "@/lib/home-desktop-config";

export function useHomeDesktopConfig(enabled = true): HomeDesktopConfig {
  const fn = useServerFn(getHomeDesktopConfig);
  const { data } = useQuery({
    queryKey: ["home-desktop-config"],
    queryFn: () => fn({ data: {} }),
    staleTime: 60_000,
    enabled,
  });
  return data?.config ?? HOME_DESKTOP_DEFAULTS;
}
